import { render, staticRenderFns } from "./Cotizr.vue?vue&type=template&id=1df4a4d7&"
import script from "./Cotizr.vue?vue&type=script&lang=js&"
export * from "./Cotizr.vue?vue&type=script&lang=js&"
import style0 from "./Cotizr.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports